var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonPlaceholders } from '../../localization/helpers.js';
let ComponentList = class ComponentList extends LitElement {
    constructor() {
        super(...arguments);
        this.searchTerm = '';
    }
    onSearchChange(e) {
        this.searchTerm = e.detail.toLowerCase();
    }
    filterComponents(components) {
        if (!this.searchTerm)
            return components;
        return components.filter(c => c.name.toLowerCase().includes(this.searchTerm) ||
            (c.description || '').toLowerCase().includes(this.searchTerm));
    }
    render() {
        if (!this.registry) {
            return html `<p>${msg('Loading components...', { id: 'componentList.loading', desc: 'Message shown while components are loading' })}</p>`;
        }
        return html `
      <div class="search-container">
        <search-bar placeholder="${CommonPlaceholders.search()}" @search-change=${this.onSearchChange}></search-bar>
      </div>
      <div class="component-sections">
      ${Object.entries(this.registry).map(([category, components]) => {
            const filteredComponents = this.filterComponents(Object.values(components));
            if (filteredComponents.length === 0)
                return html ``; // Skip empty categories
            return html `
          <component-section
            .title=${category.charAt(0).toUpperCase() + category.slice(1)}
            .components=${filteredComponents}
          </component-section>
        `;
        })}
      </div>
    `;
    }
};
ComponentList.styles = css `
  :host {
    display: flex;
    flex-direction: column;
    font-family: inherit;
    height: 100%;
    width: 100%;
    overflow: hidden;
    min-height: 0; /* ← ESSENTIEL */
  }

  .search-container {
    flex-shrink: 0;
    margin-bottom: 12px;
  }

  .component-sections {
    flex: 1;               /* ← Étire jusqu’en bas */
    min-height: 0;         /* ← Important pour que le scroll fonctionne dans un flex-container */
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;      /* Scroll ici uniquement */
    padding-right: 4px;
  }
`;
__decorate([
    property({ type: Object })
], ComponentList.prototype, "registry", void 0);
__decorate([
    state()
], ComponentList.prototype, "searchTerm", void 0);
ComponentList = __decorate([
    localized(),
    customElement('component-list')
], ComponentList);
export { ComponentList };
//# sourceMappingURL=ComponentList.js.map